export default "<p>webapp-product-sales-cafe works!</p>\r\n";